import React, { useEffect } from "react";
import Preloader from "../helper/Preloader";
import BannerTwo from "../components/BannerTwo";
import PromotionalTwo from "../components/PromotionalTwo";
import DealsOne from "../components/DealsOne";
import TopSellingOne from "../components/TopSellingOne";
import TrendingOne from "../components/TrendingOne";
import DiscountOne from "../components/DiscountOne";
import FeaturedOne from "../components/FeaturedOne";
import BigDealOne from "../components/BigDealOne";
import TopSellingTwo from "../components/TopSellingTwo";
import PopularProductsOne from "../components/PopularProductsOne";
import TopVendorsTwo from "../components/TopVendorsTwo";
import DaySaleOne from "../components/DaySaleOne";
import RecentlyViewedOne from "../components/RecentlyViewedOne";
import BrandTwo from "../components/BrandTwo";
import ShippingTwo from "../components/ShippingTwo";
import NewsletterTwo from "../components/NewsletterTwo";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Header from "../components/Header";
import { useDispatch, useSelector } from "react-redux";
import TopCategories from "../components/TopCategories";
import { fetchMainSliderData } from "../features/sliders/mainSliderSlice";
import { fetchFeaturedCategoryData } from "../features/categories/featuredCategorySlice";
import { fetchFlashDealsProductsData } from "../features/products/flashDealsSlice";
import { fetchTopPicksProductsData } from "../features/products/topPicksSlice";
import { fetchFeaturedBrandsData } from "../features/brands/featuredBrandsSlice";
import { fetchBestSellingProductsData } from "../features/products/bestSellingSlice";

const HomePage = () => {
  const dispatch = useDispatch();
  const {loading: sliderLoading, sliders, error: sliderError} = useSelector((state) => state.mainSlider)
  const {loading: categoryLoading, categories, error: categoryError} = useSelector((state) => state.featuredCategory)
  const {loading: flashDealLoading, flashDealsproducts, error: flashDealError} = useSelector((state) => state.flashDealsproducts)
  const {loading: topPicksLoading, topPicksproducts, error: topPicksError} = useSelector((state) => state.topPicksproducts)
  const {loading: bestSellingLoading, bestSellingProducts, error: bestSellingError} = useSelector((state) => state.bestSellingProducts)
  const {loading: brandsLoading, brands, error: brandsError} = useSelector((state) => state.featuredBrands)
  
  useEffect(() => {
    dispatch(fetchMainSliderData())
    dispatch(fetchFeaturedCategoryData())
    dispatch(fetchFlashDealsProductsData())
    dispatch(fetchTopPicksProductsData())
    dispatch(fetchBestSellingProductsData())
    dispatch(fetchFeaturedBrandsData())
  }, [dispatch])

  return (
    <>
      {
        sliderLoading || categoryLoading || flashDealLoading || topPicksLoading || bestSellingLoading || brandsLoading ? (
          <> 
            <ColorInit color={true} />
            <ScrollToTop smooth color="#FA6400" />
            <Preloader />
          </>
        ) : (
          <> 
            <BannerTwo sliders={sliders} />
            {/* <PromotionalTwo /> */}
            <TopCategories top_categories={categories} />
            <DealsOne  flash_deal={flashDealsproducts}/>
            <TopSellingOne top_picks={topPicksproducts} />
            <FeaturedOne bestSellingProducts={bestSellingProducts}/>
            <BrandTwo  featured_brands={brands} />
            
            {/* <TrendingOne />
            <DiscountOne />
            <FeaturedOne />
            <BigDealOne />
            <TopSellingTwo />
            <PopularProductsOne />
            <TopVendorsTwo />
            <DaySaleOne />
            <RecentlyViewedOne /> */}
            
            <ShippingTwo />
            <NewsletterTwo />
          </>
        )
      }
    </>
  );
};

export default HomePage;
